import { toast } from "react-toastify";

export const SuccessToast = (data) => {
  toast(data, {
    position: toast.POSITION.TOP_CENTER,
    type: toast.TYPE.SUCCESS,
    rtl: true,
  });
};

export const ErrorToast = (data) => {
  if (data != "") {
    toast(data, {
      position: toast.POSITION.TOP_CENTER,
      type: toast.TYPE.ERROR,
      rtl: true,
    });
  }
};

export const WarningToast = (data) => {
  toast(data, {
    position: toast.POSITION.TOP_CENTER,
    type: toast.TYPE.WARNING,
    rtl: true,
  });
};

export const InfoToast = (data, clicked, autoClose = true) => {
  toast(data, {
    position: toast.POSITION.TOP_CENTER,
    type: toast.TYPE.INFO,
    rtl: true,
    onClick: clicked,
    autoClose: autoClose,
  });
};
